import { useContext, useEffect} from "react";
import Product from "../../../Components/website/Product/Product";
import axios from "axios";
import { baseURL, Latest } from "../../../Api/Api";
import { Container } from "react-bootstrap";
import { requstData } from "../../../context/RequstContext";
import { motion } from "motion/react";
import ProductsShow from "../../../Components/website/Products/ProductsShow";
export default function LatestProducts(){
    // context data for latest products
    const reqData=useContext(requstData);
    useEffect(()=>{
        if(reqData.latestProducts.length===0)
        try{
            axios.get(`${baseURL}/${Latest}`)
            .then((data)=>
                reqData.setLatestProducts(data.data));
        }
        catch(err){
          console.log(err);
        }
    },[]);
    //Mapping
    const productShow=reqData.latestProducts.map((pro)=>
    <Product title={pro.title} id={pro.id}
     img={pro.images.length>0?pro.images[0].image:""}
     description={pro.description}
      discount={pro.discount} price={pro.price}
      rating={pro.rating}/>
    )
    return(
        reqData.latestProducts.length>0&&
          <motion.div className="d-flex position-relative align-items-start justify-content-center mb-5 w-100" 
               style={{ marginTop: '0',backgroundColor:'rgb(229 224 224 / 14%)'}}
               initial={{ opacity: 0 ,translateY:'200px'}}
               whileInView={{ opacity: 1,translateY:'0px' }}
               transition={{ duration: 0.8 }}
               viewport={{once:true}}>
        <ProductsShow data={productShow} title="Latest Products"/>
        </motion.div>
    )
}